module.exports = __webpack_public_path__ + "static/media/instagram-dark.8c9e4e67.svg";